import React, { HTMLAttributes, ReactNode } from 'react'

import { cn } from '@frame/lib/utils/cn'
import { PrimitiveDataAttribute } from '@frame/types'

type Props = {
  id?: string
  as?: 'h6' | 'div'
  children: ReactNode
  className?: HTMLAttributes<HTMLHeadingElement>['className']
}

export function H6({ children, className, as: Component = 'h6', id }: Props) {
  return (
    <Component
      data-cy={PrimitiveDataAttribute.TW_PRIMITIVE_H6}
      className={cn('text-xs font-medium text-moss-950', className)}
      id={id}
    >
      {children}
    </Component>
  )
}
